<script setup>
/**
 * The fields of the sample the owner's system sent (P-2.11), to pick from instead of typing a
 * path. Each chip is a dotted path out of the last good test's answer (`samplePaths`, worked out
 * by the sidecar); picking one writes it into the box above. No sample, no chips: the box stays
 * the plain box it was.
 */
import { useWasloI18n } from '../../i18n.js';

defineProps({
  /** Dotted paths, e.g. `message`, `error.reason`. */
  paths: { type: Array, default: () => [] },
  /** The path the box holds now, drawn as picked. */
  current: { type: String, default: '' },
});

const emit = defineEmits(['pick']);

const { t } = useWasloI18n();
</script>

<template>
  <div
    v-if="paths.length"
    class="flex flex-wrap items-center gap-1"
    data-waslo-sample-paths
  >
    <span class="text-xs text-n-slate-11">
      {{ t('WASLO.TASKS.COMPOSE.WHATIF.SYSTEM.SAMPLE_PICK') }}
    </span>
    <button
      v-for="path in paths"
      :key="path"
      type="button"
      dir="ltr"
      class="px-2 py-0.5 font-mono text-xs rounded-md"
      :class="
        current === path
          ? 'bg-n-blue-3 text-n-blue-11'
          : 'bg-n-alpha-2 text-n-slate-12 hover:bg-n-alpha-3'
      "
      :aria-pressed="current === path"
      :data-waslo-sample-path="path"
      @click="emit('pick', path)"
    >
      {{ path }}
    </button>
  </div>
</template>
